import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  
  get config() {
    return environment;
  }

  // Contact Information
  get whatsappSupport() {
    return environment.contact.whatsappSupport;
  }

  get whatsappGeneral() {
    return environment.contact.whatsappGeneral;
  }

  get supportEmail() {
    return environment.contact.supportEmail;
  }

  get salesEmail() {
    return environment.contact.salesEmail;
  }

  get phoneDisplay() {
    return environment.contact.phoneDisplay;
  }

  // URLs
  get baseUrl() {
    return environment.baseUrl;
  }

  get webAppUrl() {
    return environment.webAppUrl;
  }

  get paymentApiUrl() {
    return environment.paymentApiUrl;
  }

  get androidAppUrl() {
    return environment.apps.android.playStoreUrl;
  }

  get iosAppUrl() {
    return environment.apps.ios.appStoreUrl;
  }

  // Social Media
  get socialMedia() {
    return environment.socialMedia;
  }

  // Company Info
  get company() {
    return environment.company;
  }

  // Pricing
  get pricing() {
    return environment.pricing;
  }

  // External Links
  get externalLinks() {
    return environment.externalLinks;
  }

  // Message Templates
  get messageTemplates() {
    return environment.messageTemplates;
  }

  // WhatsApp Helper Methods
  openWhatsAppSupport(customMessage?: string) {
    const message = customMessage || environment.messageTemplates.whatsapp.support;
    const url = `https://wa.me/${environment.contact.whatsappSupport}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  openWhatsAppGeneral(customMessage?: string) {
    const message = customMessage || environment.messageTemplates.whatsapp.generalInquiry;
    const url = `https://wa.me/${environment.contact.whatsappGeneral}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  openWhatsAppPartnership() {
    const message = environment.messageTemplates.whatsapp.partnership;
    const url = `https://wa.me/${environment.contact.whatsappSupport}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  openWhatsAppSales() {
    const message = environment.messageTemplates.whatsapp.sales;
    const url = `https://wa.me/${environment.contact.whatsappSupport}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  // App Store Helper Methods
  openAndroidApp() {
    window.open(environment.apps.android.playStoreUrl, '_blank');
  }

  openIosApp() {
    window.open(environment.apps.ios.appStoreUrl, '_blank');
  }

  openWebApp() {
    window.open(environment.webAppUrl, '_blank');
  }

  // External Link Helper Methods
  openExternalLink(linkKey: keyof typeof environment.externalLinks) {
    const url = environment.externalLinks[linkKey];
    if (url) {
      window.open(url, '_blank');
    }
  }

  // Get formatted pricing string
  getFormattedPrice() {
    const { price, currencySymbol } = environment.pricing.basicPlan;
    return `${currencySymbol}${price}`;
  }



  // Feature Flags
  get features() {
    return environment.features;
  }

  get isNativeAppEnabled() {
    return environment.features.nativeApp||false;
  }

  get isChatBotEnabled() {
    return environment.features.chatBot;
  }

  get isAnalyticsEnabled() {
    return environment.features.analytics;
  }

  get isMultiLanguageEnabled() {
    return environment.features.multiLanguage;
  }

  get isDarkModeEnabled() {
    return environment.features.darkMode;
  }
}
